import React from 'react';

const LargeLogoIcon = ({ ...props }) => (
    <img
      src="/MSL Logo.png"
      alt="MSL Logo"
      style={{
        width: '250px',
        height: 'auto',
        objectFit: 'contain',
        ...props.style,
      }}
    />
);
export default LargeLogoIcon;